export function searchToObj(str) {
  let startIndex = str.indexOf("?");
  let newStr = str.slice(startIndex + 1);
  console.log(newStr);
  let arr,
    obj = {};
  if (newStr.indexOf("&") !== -1) {
    arr = newStr.split("&").map((item) => {
      return item.split("=");
    });
    arr.forEach((item) => {
      obj[item[0]] = item[1];
    });
  } else {
    arr = newStr.split("=");
    obj[arr[0]] = arr[1];
  }
  console.log(obj);
  return obj;
}

export function getUrlParam(url, param) {
  let params = url.substring(url.indexOf('?') + 1)
  params = params.split('&')
  for (let i = 0; i < params.length; i++) {
    const pair = params[i].split('=')
    if (pair[0] == param) {
      return pair[1]
    }
  }
  return false
}


export function getUrlkey(url) {
  console.log(url);
  var params = {};
  var urls = url.split("?");
  //console.log('1_分割url:', urls)
  var arr = urls[1].split("&");
  //console.log('2_分割urls[1]:', arr)
  console.log(arr);

  for (var i = 0, l = arr.length; i < l; i++) {
    //去除#号部分
    var a = arr[i].split("=");
    //console.log('3_遍历 arr 并分割后赋值给a:', a[0], a[1])

    //去除值的#号部分
    params[a[0]] = a[1].split("#")[0];
    //console.log('4_a给params对象赋值:', params)
  }
  //console.log('5_结果:', params)
  return params;
}


// 微信回调传递参数
export function changeWXString(string) {
  const str = string;
  console.log("微信回调参数", str);
  // 找到docid的位置
  let startIndex = str.indexOf("redirect_uri=") + 13;
  let endIndex = str.indexOf("&response_type");
  // 从docid的位置找最近的一个&就是需要修改的那个
  console.log(startIndex, endIndex);
  let changestr = str.slice(startIndex, endIndex);

  changestr = String.prototype.replace.call(changestr, /&/gi, "%26");
  console.log("需要改变的参数", changestr);

  let redirectUrl = str.slice(0, startIndex) + changestr + str.slice(endIndex);
  console.log("改变完返回的参数", redirectUrl);

  return redirectUrl;
}

export function getCode(str) {
  console.log('getCode', str)
}